module.exports = __webpack_public_path__ + "img/review_background.caaa7874.jpg";